import routeInvoices from './invoices.route'
import routePlans from './plans.route'
import routeSubcription from './subscriptions.route'

export default [...routeInvoices, ...routePlans, ...routeSubcription]
